import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getUrlToBackendApi, request } from '@shared/services/api';

import { GET_COIN_RACE_DETAILS_QUERY_KEY } from './use-query-coin-race-details';
import { GET_COIN_RACES_QUERY_KEY } from './use-query-coin-races';

const JOIN_COIN_RACE_URL = '/coin_races';

type JoinCoinRaceRequest = {
	id: string;
};

type JoinCoinRaceResponse = {
	status: string;
	code: number;
};

export const useMutationJoinCoinRace = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (data: JoinCoinRaceRequest) => {
			return request<JoinCoinRaceResponse>({
				method: 'post',
				url: getUrlToBackendApi(JOIN_COIN_RACE_URL).href,
				data
			});
		},
			onSuccess: () => {
				// Refresh list and details after a successful join
				queryClient.invalidateQueries({ queryKey: [GET_COIN_RACES_QUERY_KEY] });
				queryClient.invalidateQueries({ queryKey: [GET_COIN_RACE_DETAILS_QUERY_KEY] });
			}
	});
};

